import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/picture-in-picture.vue
var o = {
	name: "DtIconPictureInPicture",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--picture-in-picture"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Picture In Picture",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M1 3a1.5 1.5 0 0 1 1.5-1.5H8A1.5 1.5 0 0 1 9.5 3v1a.5.5 0 1 1-1 0V3a.5.5 0 0 0-.5-.5H2.5A.5.5 0 0 0 2 3v3a.5.5 0 0 0 .5.5h1a.5.5 0 1 1 0 1h-1A1.5 1.5 0 0 1 1 6V3Zm4 4a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 11 7v2a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 5 9V7Zm1.5-.5A.5.5 0 0 0 6 7v2a.5.5 0 0 0 .5.5h3A.5.5 0 0 0 10 9V7a.5.5 0 0 0-.5-.5h-3Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=picture-in-picture.js.map